import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectBalance, setBalance } from '../../store/accountSlice';
import { getAccountBalance } from '../api';
import { selectTotalMarginHeld } from '../../store/marginHoldSlice';

const AccountBalance = () => {
  const dispatch = useDispatch();
  // const user = useSelector(state => state.user.user);

  // const fetchBalance = async () => {
  //   if (user && user.uid) {
  //     await getAccountBalance(user.uid, dispatch);
  //   }
  // };

  // useEffect(() => {
  //   fetchBalance();
  // }, [user, dispatch]);

  const balance = useSelector(selectBalance);
  const totalMarginHeld = useSelector(selectTotalMarginHeld);
  const netBalance = (balance || 0) - (totalMarginHeld || 0);

  // Helper to format balance with commas
  function formatBalance(balance) {
    if (typeof balance !== 'number') return balance;
    return balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  return (
    <div style={{
      marginBottom: 24,
      border: '1.5px solid #e0e0e0',
      borderRadius: 12,
      background: 'linear-gradient(90deg, #f8fafd 60%, #e3eaf2 100%)',
      boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
      maxWidth: 400,
      marginTop: 24,
      padding: 16,
    }}>
      <div style={{ fontSize: 18, marginBottom: 8, color: '#1976d2' }}>
        <strong>Account Balance:</strong> ${formatBalance(balance) || '0.00'}
      </div>
      <div style={{ fontSize: 18, marginBottom: 8 }}>
        <strong>Total Margin Held:</strong> ${formatBalance(totalMarginHeld) || '0.00'}
      </div>
      <div style={{ fontSize: 18, color: '#388e3c' }}>
        <strong>Net Balance:</strong> ${formatBalance(netBalance)}
      </div>
    </div>
  );
};

export default AccountBalance;
